module.exports = __webpack_public_path__ + "staticcomp/img/marquee.79306b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/1/marquee.jpg
// module id = Wo/5
// module chunks = 39